import { cva } from 'class-variance-authority';

export const alertIndicatorVariants = cva(
  'inline-flex items-center gap-1.5 text-sm font-medium',
  {
    variants: {
      priority: {
        high: 'text-red-500',
        medium: 'text-amber-400',
        low: 'text-green-500',
      },
    },
    defaultVariants: {
      priority: 'low',
    },
  },
);

export const alertIndicatorDotVariants = cva(
  'inline-block h-3 w-3 rounded-[35%] flex-shrink-0',
  {
    variants: {
      priority: {
        high: 'bg-red-500',
        medium: 'bg-amber-400',
        low: 'bg-green-500',
      },
    },
    defaultVariants: {
      priority: 'low',
    },
  },
);
